<template>
  <teleport to="body">
    <transition name="loader-fade">
      <div
        v-if="ui.isGlobalLoading"
        class="fixed inset-0 z-[100] bg-white/80 flex items-center justify-center"
      >
        <div class="flex flex-col items-center gap-3">
          <div
            class="w-10 h-10 rounded-full border-4 border-black/10 border-t-black/70 animate-spin"
          />
          <p class="text-sm text-gray-600">Завантаження…</p>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script setup>
import { useUiStore } from "~/stores/ui";
const ui = useUiStore();
</script>

<style scoped>
.loader-fade-enter-active,
.loader-fade-leave-active {
  transition: opacity 0.15s ease;
}
.loader-fade-enter-from,
.loader-fade-leave-to {
  opacity: 0;
}
</style>
